<pbc-filter [config]="HerausgebersFilterConfig" [filter]="herausgebers.filter$ | async" (filterChange)="herausgebers.filter$.next($event)"></pbc-filter>
